<template>
	<v-app>
		<!-- layout直下だとNuxtがインスタンス生成/破棄を正しくできないため、 
		PC用, モバイル用両方ともインスタンス化して読み込む。v-ifは使わずに表示の切り替えだけ行う。 -->
		<div v-show="$vuetify.breakpoint.mdAndUp">
			<core-user-app-bar />
		</div>
		<div v-show="!$vuetify.breakpoint.mdAndUp">
			<core-mobile-user-app-bar />
		</div>
		<core-view />
		<snackbar />
		<expired-snackbar />
	</v-app>
</template>

<script>
export default {
	middleware: ['setRedirect'],
	props: {
		source: String,
	},
	data: () => ({
		drawer: null,
	}),
	components: {
		CoreUserAppBar: () => import('@/components/core/user/AppBar'),
		CoreMobileUserAppBar: () => import('@/components/core/user/MobileAppBar'),
		CoreView: () => import('@/components/core/default/View'),
		Snackbar: () => import('@/components/core/Snackbar'),
		ExpiredSnackbar: () => import('@/components/core/ExpiredSnackbar'),
	},
};
</script>

<style>
</style>
